import React from 'react';
import {HelmetProvider } from "react-helmet-async";
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'
import reportWebVitals from './reportWebVitals';
// import {ThemeProvider} from "./context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <ThemeProvider>
      <div>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </div>
    // </ThemeProvider>
  // </React.StrictMode>
);

// npx @tailwindcss/cli -i ./src/input.css -o ./src/output.css --watch

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
